import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, useAppState } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import { useEffect, useState } from "preact/hooks";


export default function Autocomplete() {
    const [isLoad, setIsLoad] = useState(false);
    const { products, keywords } = useResponse()
    const [productsAlt, setProducts] = useState(products);
    const [keywordsAlt, setkeywords] = useState(keywords);
    const [query, setQuery] = useState(null);
    const queryData = useAppState()

    const { format } = useCurrencyFormatting()

    useEffect(() => {
        if (query) {
            nostojs(api => {
                api.search({
                    query: query,
                    products: {
                        size: 6,
                        fields: [
                            "productId",
                            "url",
                            "categories",
                            "name",
                            "tags1",
                            "alternateImageUrls",
                            "imageUrl",
                            "thumbUrl",
                            "brand",
                            "availability",
                            "price",
                            "priceText",
                            "listPrice",
                            "ratingValue",
                            "reviewCount",
                            "available",
                            "skus.id",
                            "customFields.key",
                            "customFields.value"
                        ]
                    },
                    keywords: {
                        fields: ["keyword", "_highlight.keyword"],
                        facets: ["*"]
                    }
                }).then(response => {
                    setProducts(response.products)
                }).catch(error => {
                    console.error('Error:', error);
                });
            });
        }
    }, [query]);


    useEffect(() => {
        setProducts(products)
        setkeywords(keywords)

        removeActive()
        setQuery(null)
        setIsLoad(false)

    }, [products, keywords])

    useEffect(() => {
        const elements = document.querySelectorAll(".ns-autocomplete-container .ns-autocomplete-keywords .ns-autocomplete-element");
        const element = document.querySelector(".ns-autocomplete-container .ns-autocomplete-keywords .ns-autocomplete-element");

        if (!isLoad && elements) {
            elements[0]?.classList.add('active')
            elements[6]?.classList.add('active')
        }

        elements.forEach((element) => {
            element.addEventListener("mouseenter", handleHover);
        });
    }, [productsAlt]);

    function removeActive() {
        const elements = document.querySelectorAll(".ns-autocomplete-container .ns-autocomplete-keywords .ns-autocomplete-element");
        elements.forEach(el => el.classList.remove('active'))

    }

    const handleHover = (e) => {
        const elementValue = e.target.getAttribute("data-nosto-query");
        removeActive()
        if (elementValue) {
            e.target.classList.add('active')
            setQuery(elementValue);
            setIsLoad(true)
        }
    };

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }
    return (
        <div
            class="ns-autocomplete ns-autocomplete-container ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box pd-autocomplete"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    {keywordsAlt?.hits?.length > 0 ? (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 pd-autocomplete-keywords ${productsAlt?.hits?.length > 0 ? "ns-col-sm-12 ns-col-md-3" : "ns-col-sm-12"
                                }`}
                        >
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Keywords
                            </div> */}
                            <div class="ns-d-flex ns-flex-sm-column ns-flex-row ns-flex-wrap">
                                <Keywords
                                    hits={keywordsAlt.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!productsAlt?.hits?.length && <SubmitButton text={`See ${productsAlt.total} results for "${keywordsAlt?.hits[0]?.keyword}"`} />}
                        </div>
                    ) : (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 pd-autocomplete-keywords ${productsAlt?.hits?.length > 0 ? "ns-col-sm-12 ns-col-md-3" : "ns-col-sm-12"
                                }`}
                        >

                            <a href={`/search?q=${queryData.query.query}`} class="ns-d-flex ns-flex-sm-column ns-flex-row ns-flex-wrap pd-decoration-none">
                                <AutocompleteElement class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
                                    {queryData.query.query}
                                </AutocompleteElement>
                            </a>
                        </div>
                    )}
                    {productsAlt?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="ns-py-2 pd-text-uppercase ns-px-4 ns-mx-auto ns-font-4 pd-autocomplete-products-title desktop-only ns-font-thin ns-color-black-alt">
                                Product Suggestions
                            </div>
                            <div class="ns-d-flex ns-flex-wrap ns-p-5">
                                {productsAlt?.hits?.map(hit => {
                                    return (
                                        <AutocompleteElement class="pd-autocomplete-element" hit={hit}>
                                            <div
                                                data-url={hit.url}
                                                class="ns-d-flex ns-flex-column ns-clickable ns-p-2"
                                                data-nosto-element="product"
                                            >
                                                <img
                                                    class="ns-h-auto ns-object-contain ns-mx-auto"
                                                    src={hit.imageUrl ?? productImagePlaceholder}
                                                    alt={hit.name}
                                                    width="100"
                                                    height="80"
                                                />
                                                <div class="">
                                                   
                                                    <div class="ns-my-1 ns-font-4 ns-clipped ns-text-four-lines pd-autocomplete-title">
                                                        {hit.name}
                                                    </div>
                                                    <div class="pd-autocomplete-price">
                                                        <span>{format(hit.price)}</span>
                                                        {hit.listPrice && hit.listPrice > hit.price && (
                                                            <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2 pd-autocomplete-price-compare">
                                                                {format(hit.listPrice)}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>

                            <SubmitButton text={`See ${productsAlt?.total} results for "${query ? query : queryData.query.query}"`} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
